export var THDCheckboxStyles = {
    root: {
        padding: '0px',
        paddingRight: '4px',
        paddingTop: '6px',
        paddingBottom: '6px',
        '&$checked': {
            color: '#f96302',
            '&:hover': {
                backgroundColor: 'none',
            },
        },
        '&$disabled': {
            opacity: 0.3,
            '& > span': {
                pointerEvents: 'auto',
                cursor: 'not-allowed',
            },
        },
    },
    checked: {},
    disabled: {},
    indeterminate: {},
    colorPrimary: {},
    colorSecondary: {
        '&$checked': {
            '&:hover': {
                backgroundColor: 'none',
            },
        },
    },
};
